import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getTelemetry = async () => {
  const { data } = await axios.get(`${API}/telemetry`);
  return data;
};

export const getHistory = async (range = "1h") => {
  const { data } = await axios.get(`${API}/history`, { params: { range } });
  return data.points;
};

export const sendCommand = async (device, action) => {
  const { data } = await axios.post(`${API}/command`, { device, action });
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

/* Format a numeric value, returning "--" when no live data is present. */
export const fmt = (v, digits = 0, suffix = "") => {
  if (v === null || v === undefined || Number.isNaN(v)) return "--";
  return Number(v).toFixed(digits) + suffix;
};
